import React from 'react';
import { Dialog } from 'edenred-ui';

import { TopupConfirmationModalProps } from '@epi-models/pages/Transfer';

import { ConfirmationContent, OnboardingContent } from './ModalContents';
import { DialogWidth } from './TopupConfirmationModal.styles';

export const TopupConfirmationModal = ({
  showModal,
  handleTopupRequest,
  handleCloseModal,
  employeesCount,
  totalAmount,
  isTopupPending,
  showOnHoldText,
  isPendingBenefit,
  topupAmount,
  showOnboardingContent,
  topupRequestStatus,
  resetTopupStatus,
  isBatchOrder,
  isAdminTopup = false
}: TopupConfirmationModalProps) => {
  return (
    <Dialog
      PaperComponent={DialogWidth}
      open={showModal}
      onClose={handleCloseModal}
      disableBackdropClick
    >
      {showOnboardingContent ? (
        <OnboardingContent
          isTopupPending={isTopupPending}
          handleCloseModal={handleCloseModal}
          topupRequestStatus={topupRequestStatus}
          resetTopupStatus={resetTopupStatus}
        />
      ) : (
        <ConfirmationContent
          handleTopupRequest={handleTopupRequest}
          handleCloseModal={handleCloseModal}
          employeesCount={employeesCount}
          totalAmount={totalAmount}
          isTopupPending={isTopupPending}
          showOnHoldText={showOnHoldText}
          isPendingBenefit={isPendingBenefit}
          topupAmount={topupAmount}
          isBatchOrder={isBatchOrder}
          isAdminTopup={isAdminTopup}
        />
      )}
    </Dialog>
  );
};
